module.exports = __webpack_public_path__ + "static/intro.81131892.png";